import React, { Component } from "react";

import MainLayout from "../../layout";
import { CustomWebpageBar } from "../../components";

import "./index.scss";

class ExternalPlanning extends Component {
  render() {
    const { externalUrl, onReturnToKiosk } = this.props;

    return (
      <MainLayout
        content={
          <>
            <CustomWebpageBar isExternalPage onReturnToKiosk={onReturnToKiosk} />

            <iframe title="ExternalPlanning" className="ExternalPlanningPage" src={externalUrl}></iframe>
          </>
        }
      />
    );
  }
}

export default ExternalPlanning;
